import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { headerStore } from '@modules/header/adapter/outbound/stores/header.store';
import ProfileButtonContent from './Content';
export const ProfileButtonContentLogic: FC = () => {
  const router = useRouter();
  const [activePath, setActivePath] = useState('');
  const {
    setIsProfilePopupOpen
  } = headerStore(state => state);
  const handleActiveMenu = () => {
    const path = router.pathname.split('/').slice(1).join('/');
    setActivePath(path);
  };
  useEffect(() => {
    handleActiveMenu();
  }, [router]);
  useEffect(() => {
    window.addEventListener('scroll', () => setIsProfilePopupOpen(false), {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', () => setIsProfilePopupOpen(false));
    };
  }, []);
  return <ProfileButtonContent activePath={activePath} onClosePopup={() => setIsProfilePopupOpen(false)} />;
};
export default ProfileButtonContentLogic;